<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-table
        :data="questionData"
        :paginated="false"
        :row-class="(row, index) => assignRowClasses(row, index)"
      >
        <template slot-scope="props">
          <b-table-column field="question" class="text" label="Question">{{props.row.text}}</b-table-column>
          <b-table-column field="answered" class="num" label="# answers">{{props.row.answered}}</b-table-column>
          <b-table-column field="responses" label="Responses" sortable>
            <b-table
              :data="props.row.responses"
              :paginated="false"
              :row-class="(resRow, ri) => assignRowClasses(resRow, ri)"
            >
              <template slot-scope="res">
                <b-table-column field="answer" class="text" label="Option">{{res.row.label}}</b-table-column>
                <b-table-column field="num" class="num" label="#">{{res.row.num}}</b-table-column>
                <b-table-column
                  field="percent"
                  class="percent"
                  label="#"
                >{{calcPerc(res.row.num, props.row.answered)}}</b-table-column>
              </template>
            </b-table>
          </b-table-column>
          <b-table-column
            field="modifiedAt"
            class="check-column"
            label="Type"
          >{{props.row.type|toWords}}</b-table-column>
        </template>
      </b-table>

      <b-table
        :data="items"
        :paginated="true"
        :perPage="perPage"
        :total="total"
        :row-class="(row, index) => assignRowClasses(row, index)"
      >
        <template slot-scope="props">
          <b-table-column field="role" label="Answers" sortable>
            <ol class="answer-list" :title="props.row.numAnswers">
              <li
                v-for="(answer, ai) in props.row.answers"
                :key="[props.row._id,'answer', ai].join('-')"
              >
                <p class="question">{{answer.questionText}}</p>
                <p class="value">{{answer.displayValue}}</p>
              </li>
            </ol>
          </b-table-column>
          <b-table-column
            field="modifiedAt"
            class="check-column"
            label="Completed"
            sortable
          >{{props.row.modifiedAt|shortDate}}</b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getSurveyStats, getResponses } from "../api/methods";
import { mapSurvey } from "../api/mappers";
import filters from "../mixins/filters";

export default {
  name: "SurveyList",
  components: {},
  mixins: [filters],
  data() {
    return {
      questionData: [],
      items: [],
      total: 0,
      perPage: 100,
      start: 0
    };
  },
  computed: {
    ...mapGetters(["settings", "options", "questions"]),
    wrapperClasses() {
      let cls = ["surveys"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    num() {
      return this.items.length;
    }
  },
  created() {
    getSurveyStats().then(data => {
      if (data.valid) {
        this.questionData = data.questions.map(q => {
          q.responses
            .map((q, qi) => {
              q.index = qi;
              return q;
            })
            .sort((a, b) => b.num * 1000 - a.index - (a.num * 1000 - a.index));
          return q;
        });
      }
    });
    getResponses().then(data => {
      if (data instanceof Array) {
        this.items = data.map(resp => mapSurvey(resp, this.questions));
      }
    });
  },
  methods: {
    close() {
      this.showDetail = false;
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
    calcPerc(num, total) {
      return Math.round((num / total) * 100 * 100) / 100 + "%";
    }
  }
};
</script>